import styled from "@emotion/styled";
import React from "react";
import { SearchInput } from "@screens/CropsScreen/CropsScreen";
import { ReactComponent as SearchIcon } from "@assets/icons/search.svg";
import { Row } from "@components/Flex";
import { observer } from "mobx-react-lite";
import { useLang } from "@src/hooks/useLang";
import { useDevicesScreenVM } from "@screens/DevicesScreen/DevicesScreenVM";
import { useStores } from "@stores";
import { TAG_COLORS } from "@screens/DevicesScreen/DeviceFarmTags";

interface IProps {}

const Root = styled(Row)`
  margin-top: 24px;
  align-items: center;
  flex-wrap: wrap;
`;

// Filter pills are always tinted with their farm's color (matching the tag
// bubbles on each device row). The active/selected state is shown with a
// colored ring + check, so an unselected pill still reads as "the Arbyrd farm".
const Pill = styled.div<{
  active: boolean;
  background: string;
  color: string;
}>`
  font-family: Nunito Sans, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  margin-left: 8px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: 0.2s;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  box-shadow: ${({ active, color }) =>
    active ? `inset 0 0 0 2px ${color}` : "inset 0 0 0 1px transparent"};
  opacity: ${({ active }) => (active ? 1 : 0.7)};
  &:hover {
    opacity: 1;
  }
`;

const Check = styled.span`
  margin-left: 6px;
  font-size: 12px;
`;

const DevicesListHeader: React.FC<IProps> = () => {
  const lang = useLang();
  const vm = useDevicesScreenVM();
  const { farmStore } = useStores();
  return (
    <Root>
      <SearchInput
        wrapperStyle={{ width: "fit-content" }}
        placeholder={lang.crops.searchFill}
        icon={<SearchIcon />}
        value={vm.search}
        onChange={(e) => vm.setSearch(e.target.value)}
      />
      {farmStore.farms.length > 1 &&
        farmStore.farms.map((f, i) => {
          const c = TAG_COLORS[i % TAG_COLORS.length];
          const active = vm.farmFilters.includes(f.id);
          return (
            <Pill
              key={f.id}
              active={active}
              background={c.background}
              color={c.color}
              onClick={() => vm.toggleFarmFilter(f.id)}
            >
              {f.name}
              {active && <Check>✓</Check>}
            </Pill>
          );
        })}
    </Root>
  );
};
export default observer(DevicesListHeader);
